import {
  UPLOADSAMPLEFILEOFCURRENCYRATE_SUCCESS,
  UPLOADSAMPLEFILEOFCURRENCYRATE_FAILED,
  RESET_UPLOADSAMPLEFILEOFCURRENCYRATE,
  LOADING_UPLOADSAMPLEFILEOFCURRENCYRATE,
  NETWORK_ERROR_UPLOADSAMPLEFILEOFCURRENCYRATE,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetUploadSampleFileOfCurrencyRate = () => {
  return { type: RESET_UPLOADSAMPLEFILEOFCURRENCYRATE };
};

const uploadSampleFileOfCurrencyRateapi =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_UPLOADSAMPLEFILEOFCURRENCYRATE });
    await partnerServices
      .post("uploadSampleFileOfCurrencyRate", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.data.status) {
          case "Success":
            dispatch(uploadSampleFileOfCurrencyRateSuccess(res.data));
            break;
          default:
            dispatch(uploadSampleFileOfCurrencyRateFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_UPLOADSAMPLEFILEOFCURRENCYRATE,
          payload: err,
        });
      });
  };
function uploadSampleFileOfCurrencyRateSuccess(data) {
  return {
    type: UPLOADSAMPLEFILEOFCURRENCYRATE_SUCCESS,
    payload: data,
  };
}
function uploadSampleFileOfCurrencyRateFailed(data) {
  return {
    type: UPLOADSAMPLEFILEOFCURRENCYRATE_FAILED,
    payload: data,
  };
}

export {
  resetUploadSampleFileOfCurrencyRate,
  uploadSampleFileOfCurrencyRateapi,
};
